export default "__VITE_ASSET__16430dae__"